import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Dialog,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import { useState } from "react";
import { useRecoilValue } from "recoil";
import ReactLoading from "react-loading";
import { isValidEmail, PrintError } from "../../../helpers/utils";
import { useApiWrapper } from "../../../hooks/useApiWrapper";
import { ILoggedUser } from "../../../local-interfaces/local-interfaces";
import { isLoadingAtom, loggedUserAtom } from "../../../recoil/atoms";

export default function CreatePartnership() {
  const isLoading = useRecoilValue<boolean>(isLoadingAtom);
  const [emailTo, setEmailTo] = useState<string>("");
  const [validEmail, setValidEmail] = useState<boolean>(true);
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState("");
  const [isFetching, seFetching] = useState(false);


  const loggedUser = useRecoilValue<ILoggedUser | undefined>(
    loggedUserAtom
  );

  const apiWrapper = useApiWrapper();

  const handleDialogOpen = () => {
    setEmailTo("");
    setErr("");
    setValidEmail(true);
    setOpen(true);
  };

  const handleDialogClose = () => {
    setOpen(false);
  };

  const handleNewEmailTo = (ev: any) => {
    setErr("");
    setEmailTo(ev.target.value);
  };
  const handleCreatePartnership = async (event: any) => {
    seFetching(true);
    const body = {
      email_from: loggedUser?.username && encodeURIComponent(loggedUser.username),
      email_to: encodeURIComponent(emailTo),
    };
    try {
      let res = await createNewPartnership(body);
      if (res) {
        handleDialogClose();
        return;
      }
    } catch (e) {
      PrintError([e])
      setErr(`EMAIL ${e}`);
    }
    seFetching(false);
  };
  const createNewPartnership = async (body: any) => {
    //dashboard creation
    const url = "api/friendship";
    try {

      let newPartnership = await apiWrapper.postWithAuth(url, body);
      return !newPartnership.data ? undefined : newPartnership.data;
    } catch (e) {
      PrintError([e])
    }
  };

  return (
    <>
      <MenuItem
        onClick={handleDialogOpen}
        disabled={isLoading}
      >
         <ListItemIcon><GroupAddIcon /></ListItemIcon>
        <ListItemText>Add Partnership</ListItemText>

      </MenuItem>
      <Dialog open={open} onClose={handleDialogClose} fullWidth>
        <DialogTitle>Create Partnership</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Enter the client email to send request.
          </DialogContentText>
          {!isFetching && (
            <TextField
              className="searchInput"
              id="installationName"
              sx={[
                { mt: 1, maxWidth: "400px", minWidth: "400px" },
                {
                  "& .MuiFormHelperText-root.Mui-error": {
                    color: "#d32f2f !important",
                  },
                },
              ]}
              label="Client Email"
              type="email"
              variant="standard"
              error={err !== ""}
              onBlur={() => {
                setValidEmail(isValidEmail(emailTo));
              }}
              value={emailTo}
              onChange={(ev) => handleNewEmailTo(ev)}
              helperText={
                !validEmail ? "Please enter a valid email address" : 'The customer must have a K-array account.'
              }
            />
          )}
          {isFetching && (
            <ReactLoading type={"bars"} width={"60px"} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            disabled={!emailTo || !validEmail || err !== ""}
            onClick={handleCreatePartnership}
          >
            Request
          </Button>
          <Button onClick={handleDialogClose}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
